export enum Direction {
    ENTRY = 'ENTRY',
    EXIT = 'EXIT',
}
